// src/pages/PrivacyPolicy.jsx
import React from "react";
import PolicyLayout from "../components/common/PolicyLayout";
import "../components/common/styles/policyPages.css";

const PrivacyPolicy = () => {
  return (
    <PolicyLayout
      title="Consent Policy for Printed Collective Advertisements"
      subtitle="Terms and conditions governing consent for printed collective advertisements on MSZILA."
    >
      <div className="policy-card">
        {/* INTRODUCTION */}
        <section>
          <p className="policy-section-text">
            The following agreement captures the terms and conditions of use
            (&quot;Agreement&quot;), applicable to your use of MSZILA
            (&quot;Web Site&quot; &amp; &quot;Mobile App&quot;), which promotes
            business between merchants, service providers, sellers, and users
            globally by providing a digital platform for marketing,
            advertisement, selling, purchasing, or services.
          </p>

          <p className="policy-section-text">
            This Agreement is between you as the merchant, service provider,
            seller, buyer, or user of MSZILA (Web Site &amp; Mobile App) and
            ICAME SOFTWARE SOLUTIONS PRIVATE LIMITED (&quot;ICAME&quot;).
          </p>

          <p className="policy-section-text">
            MSZILA also provides a Collective Printed Advertisement Module
            separately for each district. Through this module, users can
            advertise their personal, professional, service-related, or
            business information collectively.
          </p>

          <p className="policy-section-text">
            By using our services, you acknowledge that you have read,
            understood, and agreed to the terms set out in this Consent Policy.
            If you do not agree, you may withdraw your consent at any time as
            outlined below.
          </p>
        </section>

        {/* SECTION 1 */}
        <section>
          <h3 className="policy-section-title">
            1. What are Printed Collective Advertisements?
          </h3>
          <p className="policy-section-text">
            Printed collective advertisements are physical marketing materials
            such as brochures, flyers, posters, and catalogs that may contain
            promotional content, offers, or information from Users of MSZILA.
            These advertisements may be distributed through mail, in-person
            events, or other physical distribution methods.
          </p>
        </section>

        {/* SECTION 2 */}
        <section>
          <h3 className="policy-section-title">
            2. Purpose of Printed Collective Advertisements
          </h3>
          <p className="policy-section-text">
            The printed advertisements you may enroll in are intended to:
          </p>
          <ul>
            <li>
              Inform users about products, services, or offers from MSZILA users
              and/or third-party partners.
            </li>
            <li>
              Provide a cost-effective and environment-friendly method to
              advertise services collectively, helping save paper, trees, and
              overall advertising costs.
            </li>
          </ul>
          <p className="policy-section-text">
            These advertisements aim to enhance user experience while promoting
            sustainable advertising practices.
          </p>
        </section>

        {/* SECTION 3 */}
        <section>
          <h3 className="policy-section-title">3. How We Obtain Your Consent</h3>
          <p className="policy-section-text">
            We may obtain your explicit consent to receive or participate in
            printed collective advertisements through:
          </p>
          <ul>
            <li>Opt-in during registration or checkout.</li>
            <li>
              Acceptance of an opt-in checkbox or statement on our website or
              mobile app.
            </li>
            <li>
              Acceptance of a consent prompt when engaging with paid
              advertisement-related services.
            </li>
          </ul>
          <p className="policy-section-text">
            <strong>Note:</strong> By providing consent, you agree that you are
            solely responsible for your advertisement content and any
            consequences arising from it.
          </p>
        </section>

        {/* SECTION 4 */}
        <section>
          <h3 className="policy-section-title">4. Data Collection and Privacy</h3>
          <p className="policy-section-text">
            To facilitate printed collective advertisements, we may collect and
            process certain personal information, including but not limited to:
          </p>
          <ul>
            <li>Name, address, contact details, and related information.</li>
            <li>
              Information about your engagement or response to printed
              advertisements.
            </li>
          </ul>
          <p className="policy-section-text">
            All data is handled in accordance with our Privacy Policy. We do not
            share personal information with third parties for marketing purposes
            without your consent.
          </p>
        </section>

        {/* SECTION 5 */}
        <section>
          <h3 className="policy-section-title">5. Third-Party Advertisers</h3>
          <p className="policy-section-text">
            Some printed collective advertisements may include content from
            third-party advertisers or partners. These advertisers are
            responsible for their own privacy practices and are fully
            responsible for any consequences arising from their advertisement
            content.
          </p>
        </section>

        {/* SECTION 6 */}
        <section>
          <h3 className="policy-section-title">6. Changes to This Policy</h3>
          <p className="policy-section-text">
            We may update this Consent Policy from time to time due to changes
            in marketing practices, services, or legal requirements. We
            encourage users to review this policy periodically.
          </p>
        </section>

        <div className="policy-meta">
          Last updated: 24/11/2025
        </div>
      </div>
    </PolicyLayout>
  );
};

export default PrivacyPolicy;
